// ppt-gen.common.service.ts
import { Injectable } from "@angular/core";

// Define interfaces for clarity, mirroring the component's data structures
export interface EventDetailsFormValues {
    eventName: string;
    eventStartDate: string | null;
    includeCoverPage: boolean;
    includeThankYouPage: boolean;
}

export interface AnswerFormValues {
    selected: boolean;
    questionText: string;
    answerText: string;
    originalQuestionId: number | null;
    originalAnswerId: number | null;
}

export interface VendorSubmissionFormValues {
    vendorName: string;
    vendorId: number | null;
    answers: AnswerFormValues[];
    photos: PhotoFormValues[]
    sectionHeading: string; 
}

export interface PhotoFormValues {
    selected: boolean;
    fileUrl: string; // This will now store the full URL
    fileName: string;
    base64Content: string | null; // 
    originalFileReferenceId: number | null; // 
}

@Injectable({
    providedIn: 'root'
})
export class PptGenCommonService {

    constructor() { }

    /**
     * Helper function to get choice text for multiple-choice/dropdown questions.
     * @param choiceDetails Array of choice objects.
     * @param choiceId The ID of the selected choice.
     * @returns The text of the selected choice, or 'N/A' if not found.
     */
    getChoiceText(choiceDetails: any[], choiceId: any): string {
        const choice = choiceDetails.find(c => c.id === choiceId);
        return choice ? choice.choice_text : 'N/A';
    }

    /**
     * Helper function to get the answer object for a specific question ID from a list of answers.
     * @param questionId The ID of the question.
     * @param data Array of answer objects.
     * @returns The answer object, or undefined if not found.
     */
    getAnswerForQuestion(questionId: number, data: any[]) {
        let ans: any = data.find(answerItem => answerItem.question === questionId);
        console.log(ans) // Consider removing or making this console log conditional for production
        return ans;
    }
}
